import React, { Component } from 'react'
import { connect } from 'react-redux'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'
import { withRouter } from 'react-router-dom'
import Dialog from 'react-bootstrap-dialog'
import apiService from '../services/apiservices'
import {employeesAttritionTableReady,rowsAttritonPerPageState,searchAttritionTextState,paginationAttritionState,employeesAttritionIdForAction} from '../redux/employees'
import { headerDataUpdate,subHeaderDataUpdate, expiryTokenlogout, buildNumberUpdate } from '../../../redux/user'
import {employeesIdForAction} from '../../Employees/redux/employees'
import { SearchAttritionField } from './TableCustomComponents'
import { Button } from 'react-bootstrap'
import * as Constants from '../../../common/constants'
import '../../../static/css/react-bootstrap-table.css'
import '../static/css/employeesTable.css'
//import CollapsibleRow from './CollapsibleRow'

import * as Helpers from '../../../common/helpers'

import {EmployeeAttritionStatus} from './DropDowns/index'

import { CSVLink } from 'react-csv'
import { createXLSheetdata } from '../services/helpers'

import DateRangePicker from 'react-bootstrap-daterangepicker'
import 'react-bootstrap-daterangepicker/css/daterangepicker.css'
import moment from 'moment'




function filterUnwantedData(employeesAttritionData) {
    let array = []
    if (employeesAttritionData && employeesAttritionData.data && employeesAttritionData.data.list) {
        array = employeesAttritionData.data.list
    }

    let newArray = []
    if (array.length > 0) {
        for (let i = 0; i < array.length; i++) {
            let newLineData = {}
            let lineData = array[i]
            newLineData.id = lineData.id ? lineData.id : ""
            newLineData.employee_id = lineData.employee_id ? lineData.employee_id : "NA"
            newLineData.manager_remarks = lineData.manager_remarks ? lineData.manager_remarks : "NA"
            newLineData.hr_remarks = lineData.hr_remarks ? lineData.hr_remarks : "NA"
            newLineData.status = lineData.status ? lineData.status : "NA"

            newLineData.manager_reason_name =lineData.manager_reason.name ? lineData.manager_reason.name : ""
            newLineData.hr_reason_name =lineData.hr_reason.name ? lineData.hr_reason.name : ""
            newLineData.hr_reason_id =lineData.hr_reason_id ? lineData.hr_reason_id : ""
            newLineData.employee_code =lineData.employee && lineData.employee.code && lineData.employee.code ? lineData.employee.code : ""
            newLineData.employee_name =lineData.employee && lineData.employee.name && lineData.employee.name ? lineData.employee.name : ""
            newLineData.employee_department_name =lineData.employee && lineData.employee.department && lineData.employee.department.name ? lineData.employee.department.name : "NA"
            newLineData.employee_designation_name =lineData.employee && lineData.employee.designation && lineData.employee.designation.name ? lineData.employee.designation.name : "NA"
            newLineData.employee_city_name =lineData.employee && lineData.employee.city && lineData.employee.city.name ? lineData.employee.city.name : "NA"

            newLineData.created =lineData.created ? Helpers.getDateTimeFormatForUTC(lineData.created) : "NA"
            newLineData.modified =lineData.modified ? Helpers.getDateTimeFormatForUTC(lineData.modified) : "NA"


            newLineData.last_working_day =lineData.last_working_day ? Helpers.getDateFormatForUTC(lineData.last_working_day) : "NA"

            newLineData.work_location_code=""

            if(lineData.employee.kitchen_work_location && lineData.employee.kitchen_work_location.name && lineData.employee.work_location_type==="Kitchen"){
                newLineData.work_location=lineData.employee.kitchen_work_location.name
                newLineData.work_location_code=lineData.employee.kitchen_work_location.code
            }

            if(lineData.employee.office_work_location && lineData.employee.office_work_location.name && lineData.employee.work_location_type!=="Kitchen"){
                newLineData.work_location=lineData.employee.office_work_location.name
            }


            newLineData.modified_by=""
            if(lineData.modified_details.length>0){
                newLineData.modified_by=lineData.modified_details[0] && lineData.modified_details[0].modified_user && lineData.modified_details[0].modified_user.modified_employee_profile && lineData.modified_details[0].modified_user.modified_employee_profile.name ? lineData.modified_details[0].modified_user.modified_employee_profile.name + " - "+lineData.modified_details[0].modified_user.modified_employee_profile.code : ""
            }


            newLineData.created_by=lineData.created_user && lineData.created_user.created_employee_profile && lineData.created_user.created_employee_profile.name ? lineData.created_user.created_employee_profile.name + " - "+lineData.created_user.created_employee_profile.code : ""
           


            newArray[i] = newLineData
        }
    }

    return newArray
}


class EmployeesAttritionTable extends Component {
    constructor() {
        super()
        this.state = {
            page: 1,
            employeesAttritionData: [],
            bodyHeight: "0px",
            tableHeight: "0px",
            rowCount: 15,
            filter_status:"",
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            ranges: {
                'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
            },
            rowsPerPageDropupClassname: "dropdown-menu drop-up-closed",
            isRowsPerPageDropupOpen: false,
            paginationMarginBottom: ""
        }
        this.isComponentMounted = true
        this.dialog = null
        this.searchBox = null


        this.CSVData = []
        this.createCSVData = this.createCSVData.bind(this)
    }

    componentWillMount() {
        this.isComponentMounted = true
        this.props.dispatch(employeesAttritionTableReady(false))
        this.props.dispatch(headerDataUpdate(Constants.EMPLOYEES_ATTRITION_TABLE))

        this.props.dispatch(subHeaderDataUpdate())

        window.addEventListener("resize", this.updateDimensions)
        this.updateDimensions()

        this.getEmployeesAttritionData()
        
    }

    componentDidMount() {
    }
    
    updateDimensions = () => {
        this.setState({
            tableHeight: (window.innerHeight - 230) + "px",
            bodyHeight: (window.innerHeight - 65) + "px",
        })
        if (window.innerWidth <= 767) {
            this.setState({
                paginationMarginBottom: "20px"
            })
        } else {
            this.setState({
                paginationMarginBottom: "0px"
            })
        }
    }
    
    getEmployeesAttritionData = () => {
        apiService.getEmployeesAttritionData(this.state.startDate,this.state.endDate,this.state.filter_status)
            .then(responseData => {
                if (responseData && this.isComponentMounted) {
                    this.validateBuildNumber(responseData)
                    if (responseData.status === "SUCCESS") {
                        let array = filterUnwantedData(responseData), pageNo = 1
                        if (this.props.employees && this.props.employees.previousPaginationAttritionValue) {
                            pageNo = this.props.employees.previousPaginationAttritionValue
                        }
                        this.setState({
                            employeesAttritionData: array,
                            page: pageNo,
                        })



                        this.createCSVData(array)
                    } else {
                        this.dialog.show({
                            title: "Alert",
                            body: responseData.reason ? responseData.reason : "",
                            actions: [
                                Dialog.OKAction(() => {
                                })
                            ],
                        })
                    }
                }
                this.props.dispatch(employeesAttritionTableReady(true))
            })
            .catch(err => {
                console.error("Error data: ", err)
                this.props.dispatch(employeesAttritionTableReady(true))
                if (this.isComponentMounted) {
                    this.props.dispatch(expiryTokenlogout(false))
                }
            })
    }
    componentWillUnmount() {
        this.isComponentMounted = false
        window.removeEventListener("resize", this.updateDimensions)
    }

    validateBuildNumber = (data) => {
        if (this.props.user && this.props.user.build_number && data && data.app_build_no) {
            if (this.props.user.build_number === data.app_build_no) {
                //do smthng here
            } else {
               this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
            }
        } else {
            this.props.dispatch(buildNumberUpdate(data.app_build_no))
window.location.reload()
        }
    }

    rowsperPageDropdown = () => {
        let value = 15

        if (this.props.employees && this.props.employees.previousAttritionRowsPerPageValue) {
            value = this.props.employees.previousAttritionRowsPerPageValue
        }

        return (
            <div className="container">
                <div className="dropup">
                    <Button
                        className="btn btn-default dropdown-toggle"
                        onClick={(e) => {
                            e.preventDefault()
                            this.dropUpManager()
                        }}>
                        {value}
                        <span className="caret" style={{ marginLeft: "5px" }}></span></Button>
                    <ul className={this.state.rowsPerPageDropupClassname}>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 15) }}>15</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 25) }}>25</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 40) }}>40</a></li>
                        <li><a className="drop-up-a-border-style" onClick={(e) => { this.reformateRows(e, 50) }}>50</a></li>
                    </ul>
                </div>
            </div>
        )
    }

    dropUpManager = () => {
        if (this.state.isRowsPerPageDropupOpen) {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-closed'
            })
        } else {
            this.setState({
                rowsPerPageDropupClassname: 'dropdown-menu  drop-up-open'
            })
        }
        this.setState({ isRowsPerPageDropupOpen: !this.state.isRowsPerPageDropupOpen })
    }

    reformateRows = (e, value) => {
        e.preventDefault()
        this.resetPagination()
        this.props.dispatch(rowsAttritonPerPageState(value))
        this.dropUpManager()
    }



    onApplyEvent = (event, picker) => {
        let startDate = moment(picker.startDate)
        let endDate = moment(picker.endDate)

        let api_start_date=moment(picker.startDate).format("YYYY-MM-DD")
        let api_end_date=moment(picker.endDate).format("YYYY-MM-DD")
        if (endDate.diff(endDate, 'months', true) > 1) {
            this.dialog.show({
                title: "Date chosen is greater than one month",
                body: 'Please choose any Dates within one month and then try again',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        } else {
            if (startDate.isAfter(moment().add(1, 'days')) ||
                endDate.isAfter(moment().add(1, 'days'))) {
                this.dialog.show({
                    title: "Date Chosen is greater than current date",
                    body: 'Please choose any Dates within current date and then try again',
                    actions: [
                        Dialog.OKAction(() => {
                        })
                    ],
                })
            } else {
                this.setState({
                    startDate: api_start_date,
                    endDate: api_end_date
                })
            }
        }
    }


attritionStatusChange = (data) => {
      

        if(data.value==="" || data.value===undefined){
              this.setState({
                filter_status :"",            
            })
        }else{
            this.setState({
                filter_status :data.value,
            })
        }    
            
    }

    

     renderMngReasonRemarks = (cell, row, enumObject, rowIndex,) => {
        
        let manager_reason=""
        if(row.manager_reason_name && row.manager_reason_name!=="" && row.manager_reason_name!==undefined){
        
            manager_reason=<p>{row.manager_reason_name}<br/>({row.manager_remarks})</p>
        }
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{manager_reason}</div>
        </div>)
    }


     renderHrReasonRemarks = (cell, row, enumObject, rowIndex,) => {
        
        let hr_reason=""
        if(row.hr_reason_name && row.hr_reason_name!=="" && row.hr_reason_name!==undefined){
        
            hr_reason=<p>{row.hr_reason_name}<br/>({row.hr_remarks})</p>
        }
        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{hr_reason}</div>
        </div>)
    }   


    createCSVData(csvData) {
        let attritionList = []
        if (csvData) {
            attritionList = JSON.parse(JSON.stringify(csvData))
            attritionList = createXLSheetdata(attritionList)
        }
        this.CSVData = attritionList
    }





   

    createCustomToolBar = props => {


        let attritionDetailsFilename = "attrition_data_" + moment().format("MM/DD/YYYY") + "-" +
            moment().format("h:mm:ss") + ".csv"

           let startDate = "", endDate = "", start = "", end = "", label = ""

        startDate = moment(this.state.startDate)
        endDate = moment(this.state.endDate)

        start = moment(startDate).format('DD-MM-YYYY')
        end = moment(endDate).format('DD-MM-YYYY')

        label = start + ' to ' + end;

        if (start === end) {
            label = start
        }

        let firstComponent = ''

        
            firstComponent = <div className="col-md-4 col-sm-12 col-xs-12 div-margins">
                <div className="form-group">
                    <DateRangePicker startDate={startDate}
                        endDate={endDate}
                        ranges={this.state.ranges}
                        showDropdowns={true}
                        onApply={this.onApplyEvent}>
                        <button className="date-picker-button">
                            <div className="pull-left"><i className="fa fa-calendar" /></div>
                            <span style={{ textAlign: 'center' }}>{label}</span>
                            <div className="pull-right">
                                <span className="caret"></span>
                            </div>
                        </button>
                    </DateRangePicker>
                </div>
            </div>



        return (
            <div className="row" style={{ marginLeft: "10px", marginRight: "10px" }}>
                <div className="col-xs-12 col-sm-12 col-md-9 col-lg-9 header-div-margins">
                 {firstComponent}

                <div className="col-md-2 col-sm-12 col-xs-12 div-margins">
                 <div className="form-group">
                                <EmployeeAttritionStatus attritionStatusChange={this.attritionStatusChange} selectedValue={this.state.filter_status} />    
                                </div>
                    </div>

                  <div className="col-md-3 col-sm-12 col-xs-12 div-margins">
                        <button className="btn btn-primary button-custom"
                            onClick={(e) => {
                                e.preventDefault()
                                this.getFilteredList()
                            }}>
                            Go
                        </button>
                        <button className="btn btn-primary button-custom"
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => {
                                this.resetFilterValues()
                            }}>
                            Clear
                        </button>
                         {(() =>{

                    if(Helpers.checkPrivileges("/dashboard/employeesAttrition/list",this.props.user)){
                    return(


                        <CSVLink
                                data={this.CSVData}
                                className="btn btn-primary button-custom"
                                style={{ marginLeft: "10px",background: "#3c8dbc",border:"1px solid #3c8dbc"}}
                                filename={attritionDetailsFilename}>
                                Export
                            </CSVLink>
                        )
                    }
                })()}
                    </div> 

                   
                      
                </div>
                <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 header-search-icon header-div-margins">
                    {props.components.searchPanel}
                </div>
            </div>
        )
    }
  
     createCustomFooter = props => {
        return(
            <div className="row" style={{ marginBottom: this.state.paginationMarginBottom, marginTop: "-20px" }}>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "18px" }}>
                    {props.components.sizePerPageDropdown}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4" style={{ paddingTop: "24px",textAlign:"center"}}>
                    {(() => {
                        if(this.state.employeesAttritionData.length>=(this.props.employees.previousPaginationAttritionValue*this.props.employees.previousAttritionRowsPerPageValue)){
                            return (
                            <p>
                               Showing {(this.props.employees.previousPaginationAttritionValue*this.props.employees.previousAttritionRowsPerPageValue)-this.props.employees.previousAttritionRowsPerPageValue+1} to {this.props.employees.previousPaginationAttritionValue*this.props.employees.previousAttritionRowsPerPageValue} of {this.state.employeesAttritionData.length} results
                            </p>
                            )
                        }else{
                            return (
                            <p>
                               Showing {(this.props.employees.previousPaginationAttritionValue*this.props.employees.previousAttritionRowsPerPageValue)-this.props.employees.previousAttritionRowsPerPageValue+1} to {this.state.employeesAttritionData.length} of {this.state.employeesAttritionData.length} results
                            </p>
                            )
                        }
                    })()}
                </div>
                <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4 footer-pagination-icons">
                   {props.components.pageList}
                </div>
            </div> 
        )   
    }

   
    resetSearchAndPagination = () => {
        this.props.dispatch(searchAttritionTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")
        this.resetPagination()
    }

  

     getFilteredList = () => {
       
        this.props.dispatch(employeesAttritionTableReady(false))
        this.resetSearchAndPagination()
        this.getEmployeesAttritionData()
       
    }



    resetFilterValues = () => {
        this.props.dispatch(employeesAttritionTableReady(false))
        this.setState({
            startDate: moment().startOf('month').format("YYYY-MM-DD"),
            endDate: moment().format("YYYY-MM-DD"),
            filter_status:""
        },() => {
             this.resetPagination()
        
        this.props.dispatch(searchAttritionTextState(""))
        this.searchBox.wrappedInstance.refs.searchInput.value = ""
        this.searchBox.props.search("")

        this.getEmployeesAttritionData();
        });

       

        
    }




    viewEmployee = (row) => {
        if (row && row.id) {
            this.props.dispatch(employeesIdForAction(row.employee_id))
            this.props.history.push("/dashboard/employees/view")
        } else {
            this.dialog.show({
                title: "Employees Identification number not found",
                body: 'Employees id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }




    actionButtonsCreator = (cell, row) => {

        let editEmployeeAttriton = ""

         let viewEmployye=""   


    if(Helpers.checkPrivileges("/dashboard/employees/view",this.props.user)){
            viewEmployye=<button
                title="View Employee"
                className="action-button"
                style={{ width: "30px", marginBottom: "1px",background:"green" }}
                onClick={(e) => {
                    e.preventDefault()
                    this.viewEmployee(row)
                }}>
                <i  title="View Employee" className="fa fa-eye" aria-hidden="true"></i>
            </button>
        }
        

        if(row.status==="OPEN" || (row.status==="CLOSED" && ( row.hr_reason_id===26 || row.hr_reason_id===27))){


            if(Helpers.checkPrivileges("/dashboard/employeesAttrition/edit",this.props.user)){

                    editEmployeeAttriton =       
                    <button title="Edit Employee Attrition"
                        className="action-button"
                        style={{ width: "30px", marginBottom: "1px" }}
                        onClick={(e) => {
                            e.preventDefault()
                            this.editEmployeeAttriton(row)
                        }}>
                        <i title="Edit Employee Attrition" className="fa fa-pencil-square-o" aria-hidden="true"></i>
                    </button>

                }
        
            }

        return (<div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">{viewEmployye}{editEmployeeAttriton}</div>
        </div>)
    }

     onPageChange = (page, sizePerPage) => {
        this.props.dispatch(paginationAttritionState(page))
        this.setState({
            page: page
        })
    }

    resetPagination = () => {
        if (this.props.employees && this.props.employees.previousPaginationAttritionValue
            && this.props.employees.previousPaginationAttritionValue !== 1) {
            this.props.dispatch(paginationAttritionState(1))
            this.setState({
                page: 1
            })
        }
    }

    editEmployeeAttriton = (row) => {
        if (row && row.id) {
            this.props.dispatch(employeesAttritionIdForAction(row.id))
            this.props.history.push("/dashboard/employeesAttrition/edit")
        } else {
            this.dialog.show({
                title: "EmployeesAttrition Identification number not found",
                body: 'EmployeesAttrition id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }


     addAttrition = (row) => {
        if (row && row.id) {
            this.props.dispatch(employeesAttritionIdForAction(row.id))
            this.props.history.push("/dashboard/employeesAttrition/addAttrition")
        } else {
            this.dialog.show({
                title: "EmployeesAttrition Identification number not found",
                body: 'EmployeesAttrition id is not available, So not able edit brand',
                actions: [
                    Dialog.OKAction(() => {
                    })
                ],
            })
        }
    }

   


    
    render() {
        let sizeperPage = 15

        if (this.props.employees && this.props.employees.previousAttritionRowsPerPageValue) {
            sizeperPage = this.props.employees.previousAttritionRowsPerPageValue
        }

        const options = {
            page: this.state.page,  // which page you want to show as default
            sizePerPage: sizeperPage,  // which size per page you want to locate as default
            pageStartIndex: 1, // where to start counting the pages
            paginationSize: 3,  // the pagination bar size.
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last', // Last page button text
            paginationPosition: 'bottom',  // default is bottom, top and both is all available
            sizePerPageListPosition: 'bottom',
            sizePerPageDropDown: this.rowsperPageDropdown,
            searchPanel: (props) => (<SearchAttritionField { ...props }
                callback={this.resetPagination}
                ref={el => this.searchBox = el} />),
            toolBar: this.createCustomToolBar,
            paginationPanel: this.createCustomFooter,
            onlyOneExpanding: true,
            expandRowBgColor: '#e1e5ed',
            expandBy: 'column',  //Available value is row and column, default is row.
            onPageChange: this.onPageChange,
        }
        return (
            <div className="employeesAttrition-table" style={{ marginBottom: '0px', maxHeight: this.state.bodyHeight }}>
                <Dialog ref={el => this.dialog = el} />
                <BootstrapTable
                    ref='table'
                    options={options}
                    data={this.state.employeesAttritionData}
                    pagination={true}
                    hover={false}
                    search={true}
                    headerStyle={{ border: '0px', background: '#626262', color: '#fff' }}
                    tableStyle={{ border: '0px', 'background': 'white' }}
                    bodyStyle={{ border: '0px', overflow: "auto", height: this.state.tableHeight}}                   
                    >

                     
                           {(() =>{

    if(Helpers.checkPrivileges("/dashboard/tech/only/access",this.props.user)){
            return(     
                   <TableHeaderColumn
                        dataField="id"
                        width="80"
                        dataSort={true}
                        isKey={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        ID
                    </TableHeaderColumn>

                )
            }else{
                return(

                    <TableHeaderColumn
                        dataField="id"
                        width="1"
                        isKey={true}
                        hidden={true}
                        expandable={false}
                        dataAlign='center'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Id
                    </TableHeaderColumn>


            )
        }
})()}


                    <TableHeaderColumn
                        dataField="employee_code"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                       Emp Id
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="employee_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Emp Name
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="employee_department_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Department
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="employee_designation_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Designation
                    </TableHeaderColumn>
                    

                    <TableHeaderColumn
                        dataField="work_location"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Work Location
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="employee_city_name"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        City
                    </TableHeaderColumn>


                    

                    <TableHeaderColumn
                        dataFormat={this.renderMngReasonRemarks}
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Mgr. Reason
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataFormat={this.renderHrReasonRemarks}
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        HR Reason
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="hr_reason_name"
                        dataSort={true}
                        hidden={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        HR Reason
                    </TableHeaderColumn>



                    <TableHeaderColumn
                        dataField="status"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Status
                    </TableHeaderColumn>


                    <TableHeaderColumn
                        dataField="created"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Attr. Date
                    </TableHeaderColumn>

                    <TableHeaderColumn
                        dataField="last_working_day"
                        dataSort={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        LWD
                    </TableHeaderColumn>

                    
                    
                     <TableHeaderColumn
                        //width="110"
                        dataField="id"
                        dataFormat={this.actionButtonsCreator}
                        filterFormatted={true}
                        dataAlign='left'
                        tdStyle={{ whiteSpace: 'normal' }}>
                        Actions
                    </TableHeaderColumn>
                </BootstrapTable>
            </div>
        )
    }

}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.user,
        employees: state.employees
    }
}

export default connect(mapStateToProps)(withRouter(EmployeesAttritionTable))


// WEBPACK FOOTER //
// ./src/modules/Employees/Components/EmployeesAttritionTable.js